import { MyfileModel } from "./myfile.model";

export class MyfileListModel {
    count: number = 0;
    items?: MyfileModel[];
}
